import * as React from "react";
const SvgFiRrLandLayerLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-land-layer-location_svg__a)">
      <path
        fill="#062147"
        d="M9.553 14.397a3.5 3.5 0 0 0 2.447.99 3.5 3.5 0 0 0 2.447-.99l2.502-2.448A6.96 6.96 0 0 0 19 6.999c0-1.87-.729-3.627-2.051-4.95A6.95 6.95 0 0 0 12-.001c-1.87 0-3.628.728-4.95 2.05-2.729 2.729-2.729 7.17.008 9.907zM8.464 3.464A4.97 4.97 0 0 1 12 2c1.336 0 2.591.52 3.535 1.464A4.97 4.97 0 0 1 17 7a4.96 4.96 0 0 1-1.457 3.528l-2.494 2.44a1.51 1.51 0 0 1-2.098 0l-2.487-2.432a5.01 5.01 0 0 1 0-7.072M9 6.99a3 3 0 1 1 6 0 3 3 0 0 1-6 0m15 9.777a1 1 0 0 1-.485.857l-9.861 5.917a3.21 3.21 0 0 1-3.306 0L.485 17.625a1 1 0 0 1 0-1.714l4.229-2.537a1 1 0 1 1 1.029 1.715l-2.8 1.68 8.433 5.06c.385.23.863.23 1.248 0l8.433-5.06-2.8-1.68a1 1 0 1 1 1.029-1.715l4.229 2.537a1 1 0 0 1 .485.856"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-land-layer-location_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLandLayerLocation;
